// extracted by mini-css-extract-plugin
export default {"hero":"HeroSection_hero__3y6V9","heroContainer":"HeroSection_heroContainer__euZfp","heroImage":"HeroSection_heroImage__6-SeG"};